var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 3C15.8807 3 17 4.11929 17 5.5V13.5C17 14.8807 15.8807 16 14.5 16H3.5C2.11929 16 1 14.8807 1 13.5V5.5C1 4.11929 2.11929 3 3.5 3H14.5ZM16 6.961L9.25351 10.931C9.12311 11.0077 8.96661 11.0205 8.82751 10.9693L8.74649 10.931L2 6.963V13.5C2 14.3284 2.67157 15 3.5 15H14.5C15.3284 15 16 14.3284 16 13.5V6.961ZM14.5 4H3.5C2.67157 4 2 4.67157 2 5.5V5.802L9 9.91991L16 5.801V5.5C16 4.67157 15.3284 4 14.5 4Z",
    fill: "#162395"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.9a6fe724b354e54f95763aef4bfcd723.svg";
export { ForwardRef as ReactComponent };